<div class="cal">
  <!-- Month navigation -->
  <div class="cal-nav">
    <h3 class="cal-month" aria-live="polite">{{ currentMonthLabel() }}</h3>
    <div class="flex gap-1">
      <button type="button" (click)="previousMonth()" [disabled]="!canGoPrevious()" class="cal-arrow" aria-label="Mes anterior">
        <svg class="size-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button type="button" (click)="nextMonth()" class="cal-arrow" aria-label="Mes siguiente">
        <svg class="size-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Weekday headers -->
  <div class="cal-row cal-weekdays" aria-hidden="true">
    @for (day of weekDays; track day) {
      <div>{{ day }}</div>
    }
  </div>

  @if (isLoading) {
    <div class="cal-row animate-pulse" aria-label="Cargando disponibilidad">
      @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35]; track i) {
        <div class="cal-cell"><div class="cal-skel"></div></div>
      }
    </div>
  } @else {
    <div role="grid" aria-label="Calendario de disponibilidad">
      @for (week of weeks(); track $index) {
        <div class="cal-row" role="row">
          @for (date of week; track $index) {
            <div class="cal-cell" role="gridcell">
              @if (isDayInCurrentMonth(date)) {
                <button
                  type="button"
                  (click)="selectDay(date)"
                  [disabled]="isDayDisabled(date)"
                  [attr.aria-label]="date.getDate() + ', ' + getAvailabilityText(date)"
                  [attr.aria-selected]="isSelected(date)"
                  class="cal-day"
                  [class.is-selected]="isSelected(date)"
                  [class.is-today]="isToday(date)"
                  [class.lvl-high]="getAvailabilityLevel(date) === 'high'"
                  [class.lvl-medium]="getAvailabilityLevel(date) === 'medium'"
                  [class.lvl-low]="getAvailabilityLevel(date) === 'low'"
                  [class.lvl-none]="getAvailabilityLevel(date) === 'none'">
                  {{ date.getDate() }}
                </button>
              }
            </div>
          }
        </div>
      }
    </div>

    <ul class="cal-legend">
      <li><span class="cal-swatch lvl-high" aria-hidden="true"></span>Disponible</li>
      <li><span class="cal-swatch lvl-medium" aria-hidden="true"></span>Pocos horarios</li>
      <li><span class="cal-swatch lvl-low" aria-hidden="true"></span>Últimos horarios</li>
      <li><span class="cal-swatch cal-swatch-none" aria-hidden="true">8</span>Sin horarios</li>
    </ul>
  }
</div>
